import type { FC } from "react";

import type { UseFormReturn } from "react-hook-form";

import type { LiquidityNeeds } from "~/v2/api/rest/account";
import { RadiosInput } from "../../RadiosInput";
import type { FinancialProfileForm } from "./schema";

const LABEL =
  "How likely is it for you to withdraw your investments earlier than planned?";

const OPTIONS: {
  label: string;
  value: LiquidityNeeds;
}[] = [
  { label: "Very Important to me", value: "very_important" },
  { label: "Important", value: "important" },
  { label: "Somewhat Important", value: "somewhat_important" },
  { label: "Not Important", value: "does_not_matter" },
];

type ConvertCashInputProps = {
  form: UseFormReturn<FinancialProfileForm>;
};

export const ConvertCashInput: FC<ConvertCashInputProps> = ({ form }) => {
  const {
    setValue,
    watch,
    formState: { errors },
  } = form;

  const liquidityNeeds = watch("liquidity_needs");

  const onSelect = (value: string) => {
    setValue("liquidity_needs", value as LiquidityNeeds);
  };

  return (
    <RadiosInput
      id="liquidity_needs"
      label={LABEL}
      value={liquidityNeeds}
      options={OPTIONS}
      onSelect={onSelect}
      errorMessage={errors.liquidity_needs?.message}
    />
  );
};
